import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'bnz-shared-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BnzLinkComponent {
  @HostBinding('class.bnz-shared-link') componentClass = true;

  // Adjust this if a shared link needs to  have the icon
  get shouldDisplayLinkIcon(): boolean {
    return this.showIcon;
  }

  @Input() text: string;
  @Input() path: string;
  @Input() isTargetBlank: boolean;
  @Input() showIcon = true;
  @Input() ariaLabel: string;
  @Input() contentClass: string;

  targetValue = '_self';

  isExternalPath(): boolean {
    return this.path.startsWith('http://') || this.path.startsWith('https://');
  }

  renderLink(): string {
    if (!this.path) {
      return 'buttonLink';
    }

    if (this.isExternalPath()) {
      this.setTargetValue();
      return 'externalLink';
    } else {
      return 'internalLink';
    }
  }

  private setTargetValue(): void {
    this.targetValue = this.isTargetBlank ? '_blank' : '_self';
  }

  get linkIcon(): string {
    // TE links and GC links in the PA/PT page use chevron-right
    if (this.path.includes('bnz-travel') || this.path.includes('dgengine')) {
      return 'icon-chevron-right';
    } else {
      return 'icon-read-more';
    }
  }
}
